import styled from 'styled-components';
import { Text } from 'components/Typography';
import { Colors, Screens } from 'core/CssVariables';

/* Shown only while the tracker is actually running — the design marks a live
   timer with a red dot, and a dot that never goes away would say nothing. */
export const SRunningDot = styled.span`
  display: block;
  width: 7px;
  height: 7px;
  border-radius: 50%;
  background-color: ${Colors.ShellTimerActive};
`;

export const SSeconds = styled(Text)`
  display: inline-block;
  @media (max-width: ${Screens.ScreensXS}) {
    display: none;
  }
`;

export const STimezoneText = styled(Text)`
  margin-left: 4px;
`;
